import React from 'react';
import './Clientes.css';
import Header from "./components/Header/Header";
import Welcome from "./components/Welcome/Welcome";
import Products from "./components/Products/Products";
import Map from "./components/Map/Map";
import Carousel from "./components/Carousel/Carousel";
import Footer from "./components/Footer/Footer";

function Clientes() {

    return (
        <main className="clientes__container">
            <Header/>
            <div className="clientes__bodyContainer">
                <Welcome/>
                <Products/>
                <Map />
                <Carousel />
            </div>
            <Footer />
        </main>
    );
}

export default Clientes;
